import React from 'react';
import { useContext } from 'react';
import logo from './../../assets/donna.png';
import { makeStyles } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';
import { useTenantDetails } from './useTenantDetails';
import { UserContext } from './../UserContext';
import { Link } from 'react-router-dom';
import agencyIQLogo from './../../assets/agencyIQ_Logo.png';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '100%',
  },
  logo: {
    height: 50,
  },
  logoAlt: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  tenantText: {
    marginLeft: theme.spacing(2),
  },
}));

export function AppLogo(props) {
  const {doesNotHaveTenant, noLink} = props;
  const { user } = useContext(UserContext);
  const isPowerUser = user.isPowerUser();
  const tenant = user.getTenant();
  const classes = useStyles();
  const { fetching, error, success, data: tenantDetails } = useTenantDetails();
  let agencyLogo;
  if (success) {
    ({ agencyLogo } = tenantDetails);
  }
  const showAgencyLogo = success && agencyLogo;
  const showDefaultLogo = (success && !agencyLogo) || error;

  const isSiaaAgency = user.isSiaaAgency();
  const userRole = user.getTopRole();
  let homePath = "/home";

  const NO_TENANT_HOME = "/agencyIQ"
  const ANALYTICS_PATH = "/home/analytics";
  const SCOPED_ANALYTICS_PATH = "/home/team-analytics";
  const PERSONAL_ANALYTICS_PATH = "/home/my-analytics";
  const ANALYTICS_METRICS = "/metrics";
  const POWER_USER_HOME_PATH = "/home/book-of-business";
  const ANALYTICS_METRICS_PATH = `${ANALYTICS_PATH}${ANALYTICS_METRICS}`;
  const SCOPED_ANALYTICS_METRICS_PATH = `${SCOPED_ANALYTICS_PATH}${ANALYTICS_METRICS}`;
  const PERSONAL_ANALYTICS_METRICS_PATH = `${PERSONAL_ANALYTICS_PATH}${ANALYTICS_METRICS}`;

  const AGENCYIQ_HOME_PATH = "/home/agencyIQ";
  const OVERALL_DIEM_PATH = "/home/diem/overall";
  const SCOPED_DIEM_PATH = "/home/diem/team";
  const PERSONAL_DIEM_PATH = "/home/diem/personal";

  const hasOverallDiem = user.isOverallDiemEnabled();
  const hasScopedDiem = user.isScopedDiemEnabled();
  const hasPersonalDiem = user.isPersonalDiemEnabled();

  const hasAnalytics = user.isAnalyticsEnabled();
  const hasScopedAnalytics = user.isScopedAnalyticsEnabled();
  const hasPersonalAnalytics = user.isPersonalAnalyticsEnabled();

  if(doesNotHaveTenant) {
    homePath = NO_TENANT_HOME;
  } else if (isPowerUser) {
    homePath = POWER_USER_HOME_PATH;
  } else if (isSiaaAgency) {
    let metricsPath = "";
    if (hasPersonalAnalytics) {
      metricsPath = PERSONAL_ANALYTICS_METRICS_PATH;
    } else if (hasScopedAnalytics) {
      metricsPath = SCOPED_ANALYTICS_METRICS_PATH;
    } else if (hasAnalytics) {
      metricsPath = ANALYTICS_METRICS_PATH;
    }
    homePath = userRole === "ceo" ? AGENCYIQ_HOME_PATH : metricsPath;
  } else {
    if (hasOverallDiem) {
      homePath = OVERALL_DIEM_PATH;
    } else if (hasScopedDiem) {
      homePath = SCOPED_DIEM_PATH;
    } else if (hasPersonalDiem) {
      homePath = PERSONAL_DIEM_PATH;
    }
  }

  return (
    <div className={classes.root}>
      {showAgencyLogo && (
        <Link to={homePath}>
          <img className={classes.logo} src={agencyLogo} alt={tenant} />
        </Link>
      )}
      {fetching && <Skeleton variant="rect" height={41} width={160} />}
      {showDefaultLogo && (
        <div className={classes.logoAlt}>
          {!noLink && <Link to={homePath}>
            <img
              className={classes.logo}
              src={isSiaaAgency ? agencyIQLogo : logo}
              alt="logo"
            />
          </Link>}
          {noLink && <img
              className={classes.logo}
              src={isSiaaAgency ? agencyIQLogo : logo}
              alt="logo"
            />}
        </div>
      )}
    </div>
  );
}
